module.exports = __webpack_public_path__ + "static/img/yirenweibenbg.f35dd71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/yirenweibenbg.png
// module id = y2k9
// module chunks = 1